<template>
    <single-select :config="config" :key="config.storeField"></single-select>
</template>
<script>
    import SingleSelect from '../template/SingleSelect';
    import moment from 'moment';

    export default {
        components: {SingleSelect},
        data: function () {
            return {
                config: {
                    question: 'Would you like to update your address?',
                    options: [
                        'Yes',
                        'No'
                    ],
                    storeField: 'update_address_question',
                    clickBack: function () {
                        this.$router.go(-1)
                    }.bind(this),
                    clickContinue: async function (value) {
                        if (value === 'Yes') {
                            await this.$router.push('/reg/homeAddress')
                        } else {
                            // Route based on age - adults see emergency contact, minors see guardian
                            const regData = this.$store.getters['registration/get']
                            if (moment().diff(regData.date_of_birth, 'years') < 18) {
                                await this.$router.push('/reg/updateGuardianContact')
                            } else {
                                await this.$router.push('/reg/updateEmergencyContact')
                            }
                        }
                    }.bind(this)
                }
            }
        }
    }
</script>
